export const MIN_SCREEN_WIDTH_FOR_ELI_SIDEBAR = 1200; // px
export const MAX_SCREEN_WIDTH_FOR_ELI_MOBILE_VIEW = 600; // px
export const ELI_CHAT_IS_SIDEBAR_KEY = 'eliChatIsSidebar';
export const ELI_CHAT_POSITION_KEY = 'eliChatPosition';
export const ELI_CHAT_DIMENSION_KEY = 'eliChatDimension';
export const ELI_CHAT_THREAD_ID_KEY = 'eliChatThreadId';
export const ELI_CHAT_TITLE_KEY = 'eliChatTitle';
export const ELI_CHAT_MESSAGES_KEY = 'eliChatMessages';
export const ELI_OPEN_CHAT_TYPE_KEY = 'eliOpenChatType';
export const ELI_CHAT_IS_MINIMIZED_KEY = 'eliChatIsMinimized';
export const ELI_CHAT_CONTEXT_KEY = 'eliChatContext';
export const ELI_CHAT_IS_SIDEBAR_PREFERENCE_KEY = 'eliChatIsSidebarPreference';

export const ELI_CHAT_PROJECT_HEALTH_CONTEXT = 'eli-project-health';
export const ELI_CHAT_GENERAL_CHAT_CONTEXT = 'eli-general-chat';

export const ELI_WELCOME_VARIANT_SUGGESTION = 'suggestion';
export const ELI_WELCOME_VARIANT_PROPOSE = 'propose';

export type EliSeedWelcomeMessageInterpolation = Record<
	string,
	string | number | null | undefined
>;

export type EliSeedWelcomeMessageOptions =
	| { variant: typeof ELI_WELCOME_VARIANT_SUGGESTION }
	| {
			variant: typeof ELI_WELCOME_VARIANT_PROPOSE;
			welcomeLangVar: string;
			nextActionLangVars: string[];
			welcomeInterpolation?: EliSeedWelcomeMessageInterpolation;
			nextActionInterpolation?: EliSeedWelcomeMessageInterpolation;
			includeHiUser?: boolean;
			filterMissingNextActionTranslations?: boolean;
	  };
